<template>
    <b-form-checkbox
        v-if="!loading"
        v-model="current"
        @change="save"
    />
    <b-spinner
        v-else
        small
    />
</template>

<script>
export default {
    name: 'CheckboxField',

    props: {
        name: {
            type: String,
            'default': null,
        },

        url: {
            type: String,
            required: true,
        },

        value: {
            type: Boolean,
            'default': false,
        },
    },

    data() {
        return {
            current: this.value,
            loading: false,
        };
    },

    methods: {
        save: function(checked) {
            this.loading = true;

            if (!this.name) {
                return true;
            }

            const data = {};
            data[this.name] = checked;

            this.axios.put(this.url, data)
                .then(() => {
                    this.current = checked;
                    this.loading = false;
                })
                .catch(() => {
                    this.$root.$emit('showError');
                });

            return true;
        },
    },

    watch: {
        current: function() {
            this.$emit('input', this.current);
        },

        value: function() {
            this.current = this.value;
        },
    },
};
</script>